// extracted by mini-css-extract-plugin
export default {"rightSideContainer":"thirdStep_rightSideContainer__cbtcp"};